import React from "react";
import "./Loader.css";

function Loader() {
  return (
    <>
      <div className="wrapper">
        <span className="loader"></span>
      </div>
    </>
  );
}
// Load&nbsp;ng
export default Loader;
